import { defineMessages } from 'react-intl-next';
export const messages = defineMessages({
  errorLoadingProjectsDescription: {
    id: 'proforma-jira-issue-forms.ui.general.header.error-loading-projects-description',
    defaultMessage: 'Refresh the page and try again.',
    description: 'The error description when loading projects fails for ProForma Issue Forms.'
  },
  errorLoadingProjectsTitle: {
    id: 'proforma-jira-issue-forms.ui.general.header.error-loading-projects-title',
    defaultMessage: 'We’re having trouble loading your projects',
    description: 'The error title when loading projects fails for ProForma Issue Forms.'
  },
  errorLoadingProjectAssociatedFormsDescription: {
    id: 'proforma-jira-issue-forms.ui.general.header.error-loading-project-associated-forms-description',
    defaultMessage: 'Refresh the page and try again.',
    description: 'The error description when loading the forms associated with the selected project fails for ProForma Issue Forms.'
  },
  errorLoadingProjectAssociatedFormsTitle: {
    id: 'proforma-jira-issue-forms.ui.general.header.error-loading-project-associated-forms-title',
    defaultMessage: 'We’re having trouble loading your forms',
    description: 'The error title when loading the forms associated with the selected project fails for ProForma Issue Forms.'
  },
  formPlaceholder: {
    id: 'proforma-jira-issue-forms.ui.general.header.form-placeholder',
    defaultMessage: 'Select a form',
    description: 'The form dropdown placeholder for ProForma Issue Forms.'
  },
  issueTypePlaceholder: {
    id: 'proforma-jira-issue-forms.ui.general.header.issue-type-placeholder',
    defaultMessage: 'Select an issue type',
    description: 'The issue type dropdown placeholder for ProForma Issue Forms in a non-JSM project.'
  },
  pageDescriptionEmbed: {
    id: 'proforma-jira-issue-forms.ui.general.header.page-description-embed',
    defaultMessage: 'Create issues using a form, or from a link to a form directly. <a>Learn more about using forms to create issues.</a>',
    description: 'Page description for ProForma Issue Forms.'
  },
  pageHeader: {
    id: 'proforma-jira-issue-forms.ui.general.header.page-header',
    defaultMessage: 'Create issue',
    description: 'Page header for ProForma Issue Forms.'
  },
  projectHasNoAssociatedFormsJsm: {
    id: 'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jsm',
    defaultMessage: 'This service project doesn’t have any associated forms.',
    description: 'The message when the selected service project has no associated forms for ProForma Issue Forms.'
  },
  projectHasNoAssociatedFormsJsw: {
    id: 'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jsw',
    defaultMessage: 'This software project doesn’t have any associated forms.',
    description: 'The message when the selected software project has no associated forms for ProForma Issue Forms.'
  },
  projectHasNoAssociatedFormsJwm: {
    id: 'proforma-jira-issue-forms.ui.general.header.project-has-no-associated-forms-jwm',
    defaultMessage: 'This business project doesn’t have any associated forms.',
    description: 'The message when the selected business project has no associated forms for ProForma Issue Forms.'
  },
  projectPlaceholder: {
    id: 'proforma-jira-issue-forms.ui.general.header.project-placeholder',
    defaultMessage: 'Select a project',
    description: 'The project dropdown placeholder for ProForma Issue Forms.'
  },
  requestTypePlaceholder: {
    id: 'proforma-jira-issue-forms.ui.general.header.request-type-placeholder',
    defaultMessage: 'Select a request type',
    description: 'The request type dropdown placeholder for ProForma Issue Forms in a JSM project.'
  }
});